import { FC, PropsWithChildren } from 'react';
import { useAuthContext } from '@lib/authContext';
import { useRouter } from 'next/router';
import { IconSize, Spinner, defaultColors } from '@lifechurch/react-ion';
import styled from 'styled-components';

const LoadingScreen = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.colors.gray10};
`;

export const ProtectRoute: FC<PropsWithChildren> = ({ children }) => {
  const { isAuthorized, loading } = useAuthContext();
  const router = useRouter();

  if (loading) {
    return (
      <LoadingScreen>
        <Spinner color={defaultColors.gray50} size={IconSize.XL} />
      </LoadingScreen>
    );
  }

  if (!isAuthorized && router.asPath !== '/login') {
    if (typeof window !== 'undefined') {
      window.location.replace(window.location.origin);
    }
    return null;
  }

  return <>{children}</>;
};
